export default __webpack_public_path__ + "static/gift-42d4daa9c5e94aa286d93cb6439ec74e.png";